import * as React from 'react';
import cn from 'classnames';
import { Dropdown as DropdownTPA } from 'wix-ui-tpa/Dropdown';
import { TPAComponentsProvider } from 'wix-ui-tpa/TPAComponentsConfig';
import { DropdownProps } from '../../../../types/AdaptedComponents';
import * as s from './styles.scss';
import { Text, TYPOGRAPHY } from 'wix-ui-tpa/Text';
import { DH } from '../../../../utils/DataHook';
import { UILibrary } from '../../../../types/UILibrary';
import { experimentsService } from '@wix/cashier-common/dist/src/utils/experimentsService';
import { Experiment } from '../../../../types/Experiment';

export const Dropdown: React.FC<DropdownProps> = (props) => {
  const isMobile = props.deviceType === 'mobile';

  return (
    <div data-ui-lib={'tpa' as UILibrary} data-hook={DH.Dropdown.Container}>
      {props.label && (
        <label htmlFor={props.name}>
          <Text
            className={s.label}
            data-hook={DH.PaymentDetails.DropdownField.Label}
            typography={TYPOGRAPHY.listText}
          >
            {experimentsService.isExperimentEnabled(
              Experiment.AsteriskAfterText
            ) ? (
              <>
                {props.label}
                {props.required && (
                  <span data-hook={DH.PaymentDetails.DropdownField.Asterisk}>
                    {' '}
                    *
                  </span>
                )}
              </>
            ) : (
              <>
                {props.required && (
                  <span data-hook={DH.PaymentDetails.DropdownField.Asterisk}>
                    *{' '}
                  </span>
                )}
                {props.label}
              </>
            )}
          </Text>
        </label>
      )}
      {/* need to force mobile context to use native dropdown menu */}
      <TPAComponentsProvider value={{ mobile: true }}>
        <DropdownTPA
          upgrade
          mobileNativeSelect
          className={cn({
            [s.lineTheme]: isMobile,
            [s.withoutLabel]: !props.label,
          })}
          disabled={props.disabled}
          error={!!props.errorMessage}
          errorMessage={props.errorMessage}
          initialSelectedId={props.initialSelectedId}
          placeholder={props.placeholder}
          onChange={props.onChange}
          options={props.options.map((option) => ({
            ...option,
            isSelectable: true,
          }))}
          data-hook={DH.PaymentDetails.DropdownField.Dropdown}
          aria-label={props.name}
        />
      </TPAComponentsProvider>
    </div>
  );
};
Dropdown.displayName = 'Dropdown';
